// frontend/src/admin/blockforms/TextForm.js
import React, { useState, useEffect } from 'react';
import RichTextEditor from '../RichTextEditor';
import { buildBlockSave } from './blockSaveTarget';

const API_BASE = process.env.REACT_APP_API_BASE || 'http://80.225.197.31:8001';

const TextForm = ({ level, entityId, section, editingBlock, nextOrderIndex, onSaved, onCancel }) => {
    const existing = editingBlock?.content_data || {};

    const [contentEn, setContentEn] = useState(existing.en?.content || '');
    const [contentHi, setContentHi] = useState(existing.hi?.content || '');
    const [activeTab, setActiveTab] = useState('en');
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        const handleBeforeUnload = (e) => {
            e.preventDefault();
            e.returnValue = '';
        };
        window.addEventListener('beforeunload', handleBeforeUnload);
        return () => window.removeEventListener('beforeunload', handleBeforeUnload);
    }, [contentEn, contentHi]);
    
    
    const handleSave = async () => {
        if (!contentEn || contentEn.trim() === '' || contentEn === '<p>&nbsp;</p>') {
            setError('Please enter text content (English)');
            return;
        }
        setError(null);
        setSaving(true);

        const content_data = { en: { content: contentEn } };
        if (contentHi && contentHi.trim() !== '') {
            content_data.hi = { content: contentHi };
        }

        const { url, method, payload } = buildBlockSave({
            level, entityId, section, editingBlock,
            blockType: 'text',
            contentData: content_data,
            orderIndex: nextOrderIndex,
        });

        try {
            const res = await fetch(url, {
                method,
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            });
            if (!res.ok) {
                const err = await res.json();
                throw new Error(err.detail || 'Save failed');
            }
            onSaved();
        } catch (err) {
            setError(err.message);
        } finally {
            setSaving(false);
        }
    };

    return (
        <div className="ace-form">
            <h4>{editingBlock ? 'Edit' : 'Add'} Text</h4>
            {error && <div className="ace-error">{error}</div>}

            <div style={{ display: 'flex', gap: '8px', marginBottom: '10px' }}>
                <button
                    type="button"
                    onClick={() => setActiveTab('en')}
                    style={{
                        padding: '6px 16px',
                        border: '1px solid #ced4da',
                        borderRadius: '6px',
                        background: activeTab === 'en' ? '#007bff' : '#fff',
                        color: activeTab === 'en' ? '#fff' : '#495057',
                        fontWeight: 600,
                        cursor: 'pointer'
                    }}
                >
                    English *
                </button>
                <button
                    type="button"
                    onClick={() => setActiveTab('hi')}
                    style={{
                        padding: '6px 16px',
                        border: '1px solid #ced4da',
                        borderRadius: '6px',
                        background: activeTab === 'hi' ? '#007bff' : '#fff',
                        color: activeTab === 'hi' ? '#fff' : '#495057',
                        fontWeight: 600,
                        cursor: 'pointer'
                    }}
                >
                    Hindi (optional)
                </button>
            </div>

            <div style={{ display: activeTab === 'en' ? 'block' : 'none' }}>
                <label>Text (English) *</label>
                <RichTextEditor value={contentEn} onChange={setContentEn} placeholder="Type your text here..." />
            </div>

            <div style={{ display: activeTab === 'hi' ? 'block' : 'none' }}>
                <label>Text (Hindi, optional)</label>
                <RichTextEditor value={contentHi} onChange={setContentHi} placeholder="Hindi text (optional)..." />
            </div>

            <div className="ace-form-actions">
                <button onClick={handleSave} disabled={saving}>{saving ? 'Saving...' : 'Save'}</button>
                <button onClick={onCancel} className="ace-cancel-btn">Cancel</button>
            </div>
        </div>
    );
};

export default TextForm;